import React from 'react';
import { TranslationContext } from '../App';

export function useTranslateFunction(ns, options = {}) {
  const translateHook = React.useContext(TranslationContext);
  const useTranslation = translateHook('gys-' + ns, (options = {}));

  // wrapping in object for backwards compatibility if necessary
  if (!useTranslation.t) return { t: useTranslation };

  return useTranslation;
}
